import { useContext, useRef } from 'react'
import { useIntl } from 'react-intl'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextButton from 'LuxKit/Button/TextButton'
import NavigationHeaderContactDropdown from './NavigationHeaderContactDropdown'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import ContactContext from 'contexts/contactContext'
import useToggle from 'hooks/useToggle'

interface Props {
  className?: string
}

function NavigationHeaderPhoneMenu(props: Props) {
  const intl = useIntl()
  const { className } = props
  const { value: isOpen, toggle: toggleDropdown, off: closeDropdown } = useToggle()
  const triggerRef = useRef<HTMLButtonElement | null>(null)
  const currentContact = useContext(ContactContext)
  const defaultContact = currentContact.defaultContact

  return <>
    <TextButton
      className={className}
      kind="tertiary"
      variant="default"
      onClick={toggleDropdown}
      aria-expanded={isOpen}
      aria-label={intl.formatMessage({
        id: 'Wqxl3WEVRFrsgf5RTx3g',
        defaultMessage: 'Need Help? Call our Travel Experts',
        description: 'Aria label for phone menu button in navigation header',
      })}
      startIcon={<LinePhoneIcon />}
      endIcon={<DropdownChevron open={isOpen} />}
      ref={triggerRef}
    >
      {defaultContact.humanReadable}
    </TextButton>
    <NavigationHeaderContactDropdown
      open={isOpen}
      onClose={closeDropdown}
      onItemClick={closeDropdown}
      anchorRef={triggerRef}
    />
  </>
}

export default NavigationHeaderPhoneMenu
